const VideoTitle = ({ title, overview }) => {
    return(
        <div className="w-screen aspect-video pt-[20%] px-6 md:px-24 absolute text-white bg-gradient-to-r from-black">
            <h1 className="text-2xl md:text-5xl font-bold">
                {title}
            </h1>

            <p className="hidden md:inline-block py-6 text-lg w-1/4">{overview}</p>

            <div className="">
                <button className="bg-white text-black text-bold py-1 md:py-4 px-12 text-xl  rounded-lg hover:bg-opacity-75"> ▷ Play</button>
                <button className="hidden md:inline-block bg-gray-600 text-white p-4  px-12 text-xl bg-opacity-50 rounded-lg mx-2">More Info</button>
            </div>
        </div>
    );
};

export default VideoTitle;